// snapshots.engine.ts
import { Reservation } from "src/app/models";

export type ItemSnapshot = { index: number; item: Reservation };

export function cloneReservation(r: Reservation): Reservation {
  return { ...r };
}

export function takeGroupSnapshot(
  list: Reservation[],
  resId: string
): ItemSnapshot[] {
  const shots: ItemSnapshot[] = [];
  list.forEach((r, idx) => {
    if (r.id === resId) shots.push({ index: idx, item: cloneReservation(r) });
  });
  return shots;
}

export function restoreGroupFromSnapshot(
  list: Reservation[],
  resId: string,
  shots: ItemSnapshot[]
): Reservation[] {
  if (!shots?.length) return list;
  const base = list.filter((x) => x.id !== resId);
  const ordered = [...shots].sort((a, b) => a.index - b.index);
  const next = [...base];
  for (const s of ordered) {
    const insertAt = Math.min(Math.max(s.index, 0), next.length);
    next.splice(insertAt, 0, cloneReservation(s.item));
  }
  return next;
}
